import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import axios from "axios";
import { Toast } from "../../../components";

export default function ApplyPromoCode(props) {
  const user = useSelector((state) => state.auth);
  // console.log(user.uuid)

  const {
    close,
    totalAmount,
    type,
    walletAppliedFlags,
    amnt,
    finalAmount,
    appointmentCategory,
    blockCouponid,
    couponAppliedFlags,
    PartnerUUid
  } = props;
  console.log(walletAppliedFlags, amnt, "sdfgg");
  const [couponCode, setCouponCode] = useState();
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [toastVisibility, setToastVisibility] = useState(false);
  const [amount, setAmount] = useState("");
  const [successVisibility, setSuccessVisibility] = useState(false);
  const [finalMessage, setFinalMessage] = useState("");

  const handleCoupanCode = (event) => {
    couponAppliedFlags(false);
    setCouponCode(event.target.value);
  };

  useEffect(() => {
    setAmount(totalAmount);
  }, []);

  const handleSubmit = async () => {
    try {
      if (amount == 0) {
        setToastVisibility(true);
        setToastMessage("Please select Test");
        setToastType("error");

        throw new Error("Failed");
      }

      if (couponCode == null || couponCode == undefined || couponCode == "") {
        setToastVisibility(true);
        setToastMessage("Please Enter Promo Code");
        setToastType("error");
        throw new Error("Failed");
      }

      let payLoad = {
        user_uuid: user.uuid,
        coupon_code: couponCode,
        total_amount: amount,
        type: "labtest",
        category: "labtest",
        partner_uuid:PartnerUUid
      };
      let response = await axios.post(
        `${process.env.REACT_APP_API_URL}/coupon/apply`,
        payLoad
      );
      if (response.status == 200 || response.status == 201) {
        setSuccessVisibility(true);
        console.log(response.data);
        if (
          response.data.finalmessage !== null ||
          (response.data.finalmessage !== "" &&
            response.data.finalmessage !== undefined)
        ) {
          setFinalMessage(response.data.finalmessage);
        } else {
          setFinalMessage("discount");
        }
        setAmount(response.data.finalAmount);
        if (walletAppliedFlags == true) {
          finalAmount(response.data.finalAmount - amnt);
        } else {
          finalAmount(response.data.finalAmount);
        }

        blockCouponid(response.data.coupon_applied_id);
        couponAppliedFlags(true);
      } else {
        setSuccessVisibility(false);
      }
    } catch (error) {
      if (error && error.response) {
        setToastVisibility(true);
        setToastMessage(error.response.data);
        setToastType("error");
      }
      setSuccessVisibility(false);
    }
  };

  return (
    <div className={type == "sadn" ? "SadnReasonForVisit" : "ReasonForVisit"}>
      {!successVisibility && (
        <div className={"input"}>
          {/* <small>Have a Promo Code ?</small><br></br> */}
          <small>Apply Doctall discount promo code below</small>
          <input
            style={{ marginTop: "10%", width: "175px" }}
            placeholder=""
            InputStyle={{ outline: "none !important" }}
            onChange={handleCoupanCode}
            value={couponCode}
          />
          <Button
            style={{
              backgroundColor: "#0c44ac",
              borderColor: "#0c44ac",
              marginLeft: "10px",
            }}
            onClick={handleSubmit}
          >
            Claim Promo Code
          </Button>{" "}
        </div>
      )}
      {/* If Promo Code applied sucessfully */}
      {successVisibility && (
        <div className={"input"}>
          <div className="info-container">
            <div className="info-text">
              {`Your Promo Code (${
                couponCode && couponCode
              }) was successfully applied and ${finalMessage} has been applied`}
            </div>
          </div>
        </div>
      )}

      <Toast
        text={toastMessage}
        type={toastType}
        open={toastVisibility}
        setClose={() => {
          setToastVisibility(false);
        }}
      />
    </div>
  );
}
